/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useEffect, useState } from "react";

// @mui material components
import Container from "@mui/material/Container";

// Material Dashboard 2 PRO React examples
import PageLayout from "views/LayoutContainers/PageLayout";

// Pricing page components
import Header from "layouts/pages/pricing-page/components/Header";
import Footer from "layouts/pages/pricing-page/components/Footer";
import PricingCards from "layouts/pages/pricing-page/components/PricingCards";
import TrustedBrands from "layouts/pages/pricing-page/components/TrustedBrands";
import Faq from "layouts/pages/pricing-page/components/Faq";
import { useGetAllPackagePlansQuery } from "../../../store/api/packagePlans";
import { notificationActions } from "../../../store/notification/notification-slice";
import { useDispatch } from "react-redux";
import WelcomePage from "../welcome-page";

function PricingPage() {
  const [tabValue, setTabValue] = useState(0);
  const [monthly, setMonthly] = useState();
  const [yearly, setYearly] = useState();
  const [packageData, setPackageData] = useState();

  const { data, error, isLoading } = useGetAllPackagePlansQuery();
  const dispatch = useDispatch();

  useEffect(()=>{
      dispatch(notificationActions.showLoading(isLoading));
  },[ isLoading]);

  useEffect(()=>{
    if(data){
      setMonthly(data.data.filter(d=>d.interval==="MONTHLY").sort(m=>m.price));
      setYearly(data.data.filter(d=>d.interval==="YEARLY").sort(m=>m.price));
      setPackageData(data.data.filter(d=>d.interval==="MONTHLY"));
    }
    },
    [data]);
  const handleSetTabValue = (event, newValue) => {
    setTabValue(newValue);
    if (event.currentTarget.id === "annual") {
      setPackageData(yearly);
    } else {
      setPackageData(monthly);
    }
  };

  return (
    <PageLayout>
      {/*<Header tabValue={tabValue} tabHandler={handleSetTabValue}>*/}
      {/*  <Container>*/}
      {/*    {packageData && <PricingCards packageData={packageData} />}*/}
      {/*    <TrustedBrands />*/}
      {/*    <Faq />*/}
      {/*  </Container>*/}
      {/*</Header>*/}
      {/*<Footer />*/}
      <WelcomePage/>
    </PageLayout>
  );
}

export default PricingPage;
